import { centsToPrice } from "itsf-ui-common";
import { createInstance, InitOptions } from "i18next";
import {
    accountDetails,
    addons,
    address,
    alerts,
    barrings,
    bills,
    common,
    control,
    footer,
    forgotEmail,
    glossary,
    header,
    month,
    navigation,
    order,
    payment,
    portin,
    profile,
    sim,
    usage,
    validation,
    cancelBroadband,
    appointment,
    recommendationBanner,
} from "./en/translation";

export const resources = {
    en: {
        accountDetails,
        addons,
        address,
        alerts,
        barrings,
        bills,
        common,
        control,
        footer,
        forgotEmail,
        header,
        glossary,
        navigation,
        order,
        payment,
        portin,
        profile,
        month,
        sim,
        usage,
        validation,
        cancelBroadband,
        appointment,
        recommendationBanner,
    },
} as const;

const detectBrowserLanguage = () => navigator?.languages?.[0];

export const defaultNS = "common";

const i18nOptions: InitOptions = {
    lng: detectBrowserLanguage(),
    fallbackLng: "en",
    fallbackNS: "common",
    interpolation: {
        format: (value, format) => {
            if (format === "priceFormat") {
                return `€${centsToPrice(value)}`;
            }

            return value ? value.toString() : "";
        },
        escapeValue: false,
    },
    resources,
    debug: process.env.environment === "development",
    ns: [
        "accountDetails",
        "addons",
        "alerts",
        "barrings",
        "bills",
        "common",
        "footer",
        "forgotEmail",
        "header",
        "navigation",
        "offer",
        "order",
        "payment",
        "portin",
        "profile",
        "sim",
        "usage",
        "validation",
        "cancelBroadband",
        "appointment",
        "recommendationBanner",
    ],
    defaultNS,
    react: {
        useSuspense: true,
    },
};

const i18n = createInstance();

i18n.init(i18nOptions);

export { i18n };
